import EventMitt from '@jswork/event-mitt';
import message from 'common/services/message';
import cx from 'classnames';
import { toJS } from 'mobx';
import './services/api';
import './nx/nx-packages';
import './style.scss';
import './nx/styled-box';
import './nx/react-component';
import RootStore from './v2store/root';

nx.$its = { value: nx.it('value'), label: nx.it('label') };
nx.$external = {};
nx.cx = cx;
nx.toJS = toJS;
nx.$message = message;
nx.$event = nx.mix(null, EventMitt);
nx.$storage = new nx.Store({ prefix: 'internal', purify: true });
nx.global(null);
nx.$root = new RootStore();
